export type ManageEventOrderingValue = {
  id: string;
  title: string;
  startAtUtcMilli: number;
  endAtUtcMilli: number;
};

type SortManageEventsForDefaultViewInput<Event extends ManageEventOrderingValue> = {
  events: readonly Event[];
  nowUtcMilli: number;
};

/**
 * The default view is action-oriented: an event that is still in progress or
 * starts later is shown before completed events. Active/upcoming events move
 * forward in time; completed events move backward from the most recent one.
 */
export const sortManageEventsForDefaultView = <
  Event extends ManageEventOrderingValue,
>({
  events,
  nowUtcMilli,
}: SortManageEventsForDefaultViewInput<Event>): Event[] =>
  [...events].sort((firstEvent, secondEvent) => {
    const firstIsCurrentOrUpcoming = firstEvent.endAtUtcMilli >= nowUtcMilli;
    const secondIsCurrentOrUpcoming = secondEvent.endAtUtcMilli >= nowUtcMilli;

    if (firstIsCurrentOrUpcoming !== secondIsCurrentOrUpcoming) {
      return firstIsCurrentOrUpcoming ? -1 : 1;
    }

    const dateDifference = firstIsCurrentOrUpcoming
      ? firstEvent.startAtUtcMilli - secondEvent.startAtUtcMilli
      : secondEvent.startAtUtcMilli - firstEvent.startAtUtcMilli;

    return (
      dateDifference ||
      firstEvent.title.localeCompare(secondEvent.title) ||
      firstEvent.id.localeCompare(secondEvent.id)
    );
  });
